import React from 'react'
import Page from '../components/Page'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Nav, NavItem, NavLink, TabContent, TabPane, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup, FormGroup, Spinner } from 'reactstrap'
import { MdEdit, MdDone, MdClear, MdDelete, MdSettings, MdShoppingCart, MdWarning, MdKeyboardReturn } from 'react-icons/md'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from 'axios'

import '../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../node_modules/@syncfusion/ej2-icons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css'
import '../../node_modules/@syncfusion/ej2-lists/styles/material.css'
import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css'
import '../../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css'
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, NodeSelection, PasteCleanup } from '@syncfusion/ej2-react-richtexteditor'

import classnames from 'classnames'

import moment from 'moment-timezone'

import { IconWidget, NumberWidget, TextWidget } from '../components/Widget'

class ConfigureEcartPage extends React.Component {
  _isMounted = true
  comp = StorageService.getSession('selected_org')
  access = StorageService.getSession('user_access')

  constructor(props) {
    super(props)
    this.state = {
      store_id: this.props.match.params.id,
      enable_privacypolicy: 0,
      enable_terms: 0,
      enable_faq: 0,
      privacypolicy: '',
      terms: '',
      faq: '',
    }

    this.selection = new NodeSelection()
    this.toolbarSettings = {
      items: [
        'Bold',
        'Italic',
        'Underline',
        // 'StrikeThrough',
        //'FontName',
        'FontSize',
        //'FontColor',
        // 'BackgroundColor',
        // 'LowerCase',
        // 'UpperCase',
        // '|',
        //'Formats',
        // 'Alignments',
        // 'OrderedList',
        // 'UnorderedList',
        // 'Outdent',
        // 'Indent',
        // '|',
        // 'CreateLink',
        // 'Image',
        // '|',
        //'ClearFormat',
        // 'Print',
        // 'SourceCode',
        // 'FullScreen',
        // '|',
        'Undo',
        'Redo',
      ],
    }
    this.pasteCleanupSettings = {
      allowedStyleProps: ['font-size'],
      deniedAttrs: ['class', 'title', 'id'],
      deniedTags: ['a'],
      keepFormat: false,
      plainText: true,
      prompt: false,
    }
  }

  ppHandler = value => {
    this.setState({ privacypolicy: value.value })
  }

  tncHandler = value => {
    this.setState({ terms: value.value })
  }

  faqHandler = value => {
    this.setState({ faq: value.value })
  }

  componentDidMount() {
    this.getEcartPage()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getEcartPage = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')

    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
    }

    axios
      .post(url + ':3001/v1/store/ecartpage', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          console.log(result)
          this.setState({
            enable_privacypolicy: result.data.enable_privacypolicy,
            enable_terms: result.data.enable_terms,
            enable_faq: result.data.enable_faq,
            privacypolicy: result.data.privacypolicy,
            terms: result.data.terms,
            faq: result.data.faq,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      enable_privacypolicy: this.state.enable_privacypolicy,
      privacypolicy: this.state.privacypolicy == null ? '' : this.state.privacypolicy,
      enable_terms: this.state.enable_terms,
      terms: this.state.terms == null ? '' : this.state.terms,
      enable_faq: this.state.enable_faq,
      faq: this.state.faq == null ? '' : this.state.faq,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/ecartpage/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Store ecart page updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.getEcartPage()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    return (
      <Page
        className="ConfigureEcartPage"
        title="Configure Ecart Page"
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posstore' },
          { name: 'Detail', active: false, path: '/posstore/' + this.state.store_id },
          { name: 'Configure Page', active: true, path: '/posstore:id/configureecart' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Form className="AuthForm" onSubmit={this.handleSubmit}>
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="enable_privacypolicy" checked={this.state.enable_privacypolicy} onChange={this.checkHandler} />
                      Enable Privacy Policy
                    </Label>
                  </FormGroup>
                  <br />
                  <FormGroup>
                    <Label>Privacy Policy</Label>
                    <RichTextEditorComponent height={250} toolbarSettings={this.toolbarSettings} pasteCleanupSettings={this.pasteCleanupSettings} value={this.state.privacypolicy} change={this.ppHandler}>
                      <Inject services={[Toolbar, Link, HtmlEditor, QuickToolbar, PasteCleanup]} />
                    </RichTextEditorComponent>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="enable_terms" checked={this.state.enable_terms} onChange={this.checkHandler} />
                      Enable Terms and Condition
                    </Label>
                  </FormGroup>
                  <br />
                  <FormGroup>
                    <Label>Terms and Condition</Label>
                    <RichTextEditorComponent height={250} toolbarSettings={this.toolbarSettings} pasteCleanupSettings={this.pasteCleanupSettings} value={this.state.terms} change={this.tncHandler}>
                      <Inject services={[Toolbar, Link, HtmlEditor, QuickToolbar, PasteCleanup]} />
                    </RichTextEditorComponent>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" name="enable_faq" checked={this.state.enable_faq} onChange={this.checkHandler} />
                      Enable FAQ
                    </Label>
                  </FormGroup>
                  <br />
                  <FormGroup>
                    <Label>FAQ</Label>
                    <RichTextEditorComponent height={250} toolbarSettings={this.toolbarSettings} pasteCleanupSettings={this.pasteCleanupSettings} value={this.state.faq} change={this.faqHandler}>
                      <Inject services={[Toolbar, Link, HtmlEditor, QuickToolbar, PasteCleanup]} />
                    </RichTextEditorComponent>
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="ps-btn-group text-left">
                <Button
                  className="theme-button theme-button-dark"
                  onClick={() => {
                    window.history.back()
                  }}>
                  <MdKeyboardReturn />
                  Back
                </Button>
              </div>
            </Col>
            <Col>
              <div className="ps-btn-group text-right">
                <Button className="theme-button theme-button-primary" type="submit">
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Page>
    )
  }
}

export default ConfigureEcartPage
